// const  defaultValidator = {
//     fileldName: {
//         rules: [
//             {
//                 test: /.*/,
//                 message: 'Please Enter Valid Name',
//             },
//             {
//                 test: (value) => {
//                     return value.length > 1;
//                 },
//                 message: 'Can not be less then 2 character',
//             },
//         ],
//         errors: [],
//         valid: false,
//         state: '',
//     },
// };

import React from "react";

/**
 * Common Validator class
 */
class CommonValidator {
    /**
     * @param {Object} validator
     */
    constructor(validator) {
        this.validator = validator;
    }

    /**
     * @param {String} fieldName
     * @param {String|Number} value
     */
    checkField(fieldName, value) {
        if (this.validator[fieldName]) {
            this.validator[fieldName].errors = [];
            this.validator[fieldName].state = value;
            this.validator[fieldName].valid = true;
            this.validator[fieldName].rules.forEach(rule => {
                if (rule.test instanceof RegExp) {
                    if (!rule.test.test(value)) {
                        this.validator[fieldName].errors.push(rule.message);
                        this.validator[fieldName].valid = false;
                    }
                } else if (typeof rule.test === 'function') {
                    if (!rule.test(value)) {
                        this.validator[fieldName].errors.push(rule.message);
                        this.validator[fieldName].valid = false;
                    }
                }
            });
        }
    }

    /**
     * @param {String} fieldName
     */
    resetErrors(fieldName) {
        if (this.validator[fieldName]) {
            this.validator[fieldName].errors = [];
            this.validator[fieldName].state = '';
            this.validator[fieldName].valid = true;
        }
    }

    resetAllErrors() {
        Object.keys(this.validator).forEach(elem => {
            this.validator[elem].errors = [];
            this.validator[elem].state = '';
            this.validator[elem].valid = true;
        });
    }

    /**
     * @returns {boolean}
     */
    isValid() {
        let status = true;
        Object.keys(this.validator).forEach(field => {
            if (this.validator[field].errors.length || !this.validator[field].valid) {
                status = false;
            }
        });
        return status;
    };

    showErrors(fieldName) {
        const validator = this.validator[fieldName];
        const result = '';
        if (validator && !validator.valid) {
            const errors = validator.errors.map((info, index) => {
                return (
                    <span className="error" key={index}>
           			 	* {info}
                        <br/>
          			</span>
                );
            });
            return <div className="error mb-2">{errors}</div>;
        }
        return result;
    };

}

export default CommonValidator;


// WEBPACK FOOTER //
// ./src/helpers/CommonValidator.js